import * as z from "zod";

const validationSchema = z.object({
  userId: z.number(),
  firstname: z.string().min(1, { message: "validation:firstNameRequired" }),
  lastname: z.string().min(1, { message: "validation:lastNameRequired" }),
  email: z.string().email({ message: "validation:emailRequired" }),
  phone: z.string(),
  languageId: z.string(),
  receiveCopyOfTradingNotifications: z.boolean(),
});

export const UpdateUserValidationSchema = validationSchema;
export type UpdateUserFormInput = z.infer<typeof UpdateUserValidationSchema>;
